@if ({
  isMdOrAbove: viewportSelectors.isMdAndUp | select,
}; as vm) {
  <div class="flex flex-row text-wrap gap-3 md:gap-5 items-center md:items-start">
    <!-- Cover Image -->
    <a pxNamedRouterLink="CATALOG_BIB_DETAILS" [pxNamedRouterLinkParams]="{id: catalogRecord.id}">
      <mx-cover-image [catalogRecord]="catalogRecord" [widthRem]="8.75" [heightRem]="vm.isMdOrAbove ? 10.75 : 8" [priority]="true"/>
    </a>

    <!-- Details -->
    <div class="flex flex-col gap-1 py-4">
      <a pxNamedRouterLink="CATALOG_BIB_DETAILS" [pxNamedRouterLinkParams]="{id: catalogRecord.id}" mxTruncate [mxTruncateMaxLines]="3">
        <div class="text-headline-small">
          {{ selectors.titleFor(catalogRecord) | select | format: 'REPLACE_EMPTY' }}
        </div>
      </a>
      <div>by {{ selectors.authorFor(catalogRecord) | select | format: 'REPLACE_EMPTY' }}</div>
      <div>{{ selectors.materialTypeDescriptionFor(catalogRecord) | select | format: 'REPLACE_EMPTY' }}</div>
      <div>{{ selectors.publicationDate(catalogRecord) | select | format: 'REPLACE_EMPTY' }}</div>
      <div class="text-title-medium">{{ selectors.marcDetailsSeriesStringFor(catalogRecord) | select }}</div>
    </div>
  </div>
}
